import React, { Fragment, useState, useRef, useEffect } from 'react';
import arrayMutators from 'final-form-arrays';
import { Form, Field } from 'react-final-form';
import Popup from './Popup';
import MessageIcon from '@material-ui/icons/QuestionAnswer';
import DealSelect from './DealSelect';
import Grid from '@material-ui/core/Grid';
import { Date_picker, TextEditor, Select as Select_tool } from '../../../../../../../components';


import { connect } from 'react-redux';
import { Typography } from '@material-ui/core';





//None of the updates you made require notifying attendees.



function Messages(props) {
    let formRef = useRef(); 
    let fp = useRef();
    const [initial_json, setInitialJsonState] = useState(undefined);
    const [delete_mode, setDeleteMode]=useState(false);

    
    
    
    function setInitialJson(initial_message) {
        if(initial_message!=undefined){
            let initial_deal_id = (initial_message != undefined && initial_message.deal_id != undefined) ? initial_message.deal_id : (props.main_deals == undefined || props.main_deals[props.company.id] == undefined) ? undefined : props.main_deals[props.company.id];
            initial_message.initial_deal_id=initial_deal_id;
            if(initial_message.sub_type==undefined){initial_message.sub_type=0;}
            if(initial_message.timeline_item_message==undefined){initial_message.timeline_item_message={};}
            if(initial_message.timeline_item_message.message_type_id==undefined){initial_message.timeline_item_message.message_type_id=localStorage.getItem('message_type_id');}
            if(initial_message.contact_id!=undefined && initial_message.timeline_item_message.contact_phone_number_id==undefined){
                for (let contact of props.company.contacts) {
                    if (contact.id == initial_message.contact_id) {
                        if(contact.contact_phone_numbers.length>0){
                            initial_message.timeline_item_message.contact_phone_number_id=contact.contact_phone_numbers[0].id;
                        }
                    }
                }
            }
        }
        setInitialJsonState(initial_message);
    }

    useEffect(() => {
        if(props.message_types==undefined){
            props.getMessageTypes();
        }
        if(props.initial_message!=undefined){console.log(JSON.parse(JSON.stringify(props.initial_message)), 'INITIAL MESSAGE')}
        if (props.initial_message != undefined && props.initial_message.id != undefined && props.initial_message.draft!=true) {
            axios.get('/api/timeline_items/' + props.timeline_item.id).then(function (response) {
                props.updateSuccess({ timeline_item: response.data });
                setInitialJson(response.data);
            });
        } else {
            setInitialJson(props.initial_message);
        }
    }, [props.initial_message]);


    console.log(initial_json,'INITIAL JSON');


    

    function onSubmit(params) {
        formRef.current.reportValidity();
        if (formRef.current.checkValidity() == true) {
            let asterix_and_underscore=false;
            if(params.timeline_item_message.message_type_id=='WHATSAPP'){asterix_and_underscore=true;}
            let only_text = window.removeHTMLTags(params.content, asterix_and_underscore);
            props.copyToClipboard(only_text);
            localStorage.setItem('message_type_id', params.timeline_item_message.message_type_id);
            params.timeline_item_message.content_only_text=only_text;
            window.setTimeout(function(){
                if (params.id != undefined) { props.updateTimelineItem(params.id, 'messages', params); }
                else { props.createTimelineItem('messages', { ...params, company_id: props.company.id }); }
                props.handleClose();
            },1000);
        }else{
            console.log(params, 'PARAMS');
        }
    }

    let contact_list = [{ id: null, name: 'No contact' }];
    if (props.company != undefined) {
        for (let x of props.company.contacts) {
            if (x.pivot.active_at_company == true) {
                let contact = { id: x.id };
                if (x.first_name != null) { contact.name = x.first_name + ' '; }
                if (x.last_name != null) { contact.name += x.last_name; }
                if (contact.name == undefined) { contact.name = 'No name'; }
                contact_list.push(contact);
            }
        }
    }


    let message_types=[]; if(props.message_types!=undefined){message_types=props.message_types;}



    return(
        <Popup initial_values={props.initial_message} openDraft={props.reOpen} draft_type="MESSAGE" company_id={props.company.id} form_props={fp} maxWidth='730px' button_text={(delete_mode == true) ? 'Delete' : 'Save'} title={(delete_mode == true) ? 'Delete message' : (props.timeline_item != undefined) ? 'Update message' : 'Send message'} icon={<MessageIcon color='primary' />} handleClose={props.handleClose} handleDelete={(initial_json == undefined || initial_json.id == undefined || delete_mode == true) ? undefined : () => { setDeleteMode(true); }} accept_button_click={() => { if (delete_mode == true) { props.deleteTimelineItem(initial_json.id, 'messages', props.company.id); props.handleClose(); }else{fp.current.form.submit();}}} content={
            <Form
                onSubmit={onSubmit}
                initialValues={initial_json}
                mutators={{
                    ...arrayMutators
                }}
            >{form_props => {
                fp.current = form_props; 
                return (
                    <form style={{ maxWidth: '700px', width:'90vw' }} ref={formRef} onSubmit={form_props.handleSubmit}>
                        {(delete_mode==true)?
                            <Typography style={{ width: 'calc(100% - 40px)', height: '100px', marginTop: '50px', textAlign: 'center' }}>Are you sure you want to delete this message? This action can not be undone.</Typography>
                        :
                        <Grid container style={{ width: 'calc(100% - 40px)' }}>
                            <Field name='timeline_item_message.contact_phone_number_id'>{(f_cpn)=>
                                <Grid item xs={12} sm={6} style={{ marginBottom: '10px' }}><Select_tool title='Contact' name='contact_id' variant='outlined' size='small' select_data={contact_list} onChange={(e)=>{for(let contact of props.company.contacts){if(contact.id==e.target.value){let cpn_id=undefined;if(contact.contact_phone_numbers[0]!=undefined){cpn_id=contact.contact_phone_numbers[0].id;} f_cpn.input.onChange(cpn_id);}}}} /></Grid>
                            }</Field>
                            <Field name="contact_id">{(f)=>{
                                let contact_phone_number_list=[];
                                for(let contact of props.company.contacts){
                                    if(contact.id==f.input.value){
                                        for(let cpn of contact.contact_phone_numbers){
                                            contact_phone_number_list.push({id:cpn.id, name:cpn.name+': '+cpn.phone_number});
                                        }
                                    }
                                }
                                if(contact_phone_number_list.length==0){return (<Grid item xs={12}sm={6}/>);}
                                return (<Grid item xs={12} sm={6} style={{ marginBottom: '10px' }}><Select_tool title='Phone number' name='timeline_item_message.contact_phone_number_id' variant='outlined' size='small' select_data={contact_phone_number_list} /></Grid>
                            );
                            }}</Field>
                            <DealSelect {...props} />
                            <Grid item xs={12} sm={6} style={{ marginBottom: '10px' }}><Field name='date_time'>{(f) => <Date_picker date_time title='Date' value={f.input.value} onChange={f.input.onChange} />}</Field></Grid>
                            <Grid item xs={12} sm={6}></Grid>
                            <Grid item xs={12} sm={6} style={{ marginBottom: '10px' }}><Select_tool title='Direction' required name='sub_type' select_data={[{ value: 0, name: 'Sent message' }, { value: 1, name: 'Received Message' }]} /></Grid>
                            <Grid item xs={12} sm={6} style={{ marginBottom: '10px' }}><Select_tool title='Message type' required name='timeline_item_message.message_type_id' variant='outlined' size='small' select_data={message_types} /></Grid>
                            <Grid item xs={12}><div style={{ width: 'calc(100% - 20px)', marginLeft: '10px', marginTop: '5px' }}><Field name='timeline_item_content.content'>{(f) => <TextEditor required no_html value={f.input.value} onChange={(e) => { f.input.onChange(e) }} />}</Field></div></Grid>
                        </Grid>}
                    </form>)
                }}
            </Form>}/>
    );
}

export default connect(ss, dd)(Messages);

function ss(state) {
    return {
        message_types:state.account.message_types,
        refresh:state.account.refresh
    }
}


function dd(dispatch) {
    return {
        copyToClipboard: (text) => {dispatch({ type:'REQUEST_COPY_TO_CLIPBOARD', val:text})},
        getMessageTypes:()=>{dispatch({type:'REQUEST_INDEX_MESSAGE_TYPES'})},
        updateSuccess: (data) => { dispatch({ type: 'REQUEST_TIMELINE_ITEM_UPDATE_SUCCESS', val: data }); },
    }
}